// extracted by mini-css-extract-plugin
module.exports = {"r-mobile":"EmployeeSection_r-mobile__GG8TY","r-not-mobile":"EmployeeSection_r-not-mobile__Q7dx9","button__wrapper":"EmployeeSection_button__wrapper__3GutS"};